import { useSyncExternalStore } from "react";
import { getCurrentLocale, subscribe, pageLocale } from "../utlis/locale";

/**
 * Reactive drop-in replacement for `pageLocale(section)`.
 *
 * Returns the whole section object (English fallback baked in), and re-renders
 * the component when the language changes. Existing callers that do
 * `const t = pageLocale("mmtLogin"); ... t.title` migrate by swapping the call:
 *
 *   const t = useSection("mmtLogin");   // now reactive, `t.title` unchanged
 *
 * @param {string} section Bundle section name.
 */
const useSection = (section) => {
  // Re-render on locale change; the returned value is recomputed each render.
  useSyncExternalStore(subscribe, getCurrentLocale);
  return pageLocale(section);
};

export { useSection };
export default useSection;
